import React from "react";
import uklogo from "../../assets/kangaroo/uk_logo-cropped.svg";
import { Col, Row } from "reactstrap";
import button from "../../assets/kangaroo/button-cropped.svg";
import { useNavigate } from "react-router-dom";
import { ArrowButton } from "../../component/button/ArrowButton";

const O1component = ({ isMobile, data }) => {
  const router = useNavigate()
  return (
    <>
      {!isMobile ? (
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 452.6 328.4"
          width="57%"
          height="auto"
          transform="translate(150,-20)"

        >
          <g onClick={() => router(data?.[0]?.buttonUrl)} style={{ cursor: "pointer" }}>
            <text
              transform="translate(73.45 300.98)"
              style={{
                fill: data?.[0]?.buttonColor,
                fontFamily: "Proxima Nova Bold, 'Proxima Nova'",
                fontSize: "18.83px",
                fontWeight: 700,

              }}

            >
              {data?.[0]?.buttonText?.split("/n").map((line, index) => (
                <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                  {line}
                </tspan>
              ))}
            </text>
            <path
              d="M241.24,259.2H34.95c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33H.94c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
              fill="none"
              stroke={data?.[0]?.buttonColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <rect
              x="0"
              y="255"
              width="280"
              height="95"
              fill="transparent"
              pointerEvents="all"
            />
          </g>

          <foreignObject
            x="0.94"
            y="0.76"
            width="500"    // set your desired fixed width
            height="200"   // set enough height for all lines
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Black, Proxima Nova",
                fontSize: "52px",
                fontWeight: 800,
                color: data?.[0]?.titleColor,
                lineHeight: "1",
                wordWrap: "break-word",
              }}
            >

              {data?.[0]?.title?.split("/n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}



            </div>
          </foreignObject>

          <foreignObject
            x="1.94"
            y="165.21"
            width="450"
            height="100"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Regular, Proxima Nova",
                fontSize: "22px",
                color: "black",
                lineHeight: "1.1",
                wordWrap: "break-word",
              }}
            >
              {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </div>
          </foreignObject>
        </svg>) : (<svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 649.54 172.02"
          width="100%"
          height="100%"
        >
          {/* SEE DETAILS text */}

          {/* OPEN DOORS TO YOUR AMERICAN DREAM text */}


          <foreignObject
            x="202.94"
            y="-4"        // match the y from your <text> transform
            width="500"      // set your desired width
            height="200"     // enough height for all lines
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Black, Proxima Nova",
                fontSize: "39px",        // match your <text> font size
                fontWeight: 800,
                color: data?.[0]?.titleColor,
                lineHeight: "1.05",      // adjust line spacing
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                margin: 0,
                padding: 0,
              }}
            >
              {data?.[0]?.title?.split("/n")}
            </div>
          </foreignObject>

          {/* Smaller description text */}


          <foreignObject
            x="0"
            y="95.61"
            width="350"
            height="120"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                fontFamily: "Proxima Nova Regular",
                fontSize: "22px",
                color: "black",
                lineHeight: "1.1",
                wordWrap: "break-word",
              }}
            >
              {data?.[0]?.subTitle?.split("/n").map((line, index) => (
                <div key={index} style={{ lineHeight: "1.05" }}>
                  {line}
                </div>
              ))}
            </div>
          </foreignObject>
          <g onClick={() => router(data?.[0]?.buttonUrl)} transform="translate(50,0)">

            <text
              transform="translate(385.67 144.61)"
              style={{
                fontFamily: "Proxima Nova Bold",
                fontSize: "18.83px",
                fontWeight: 700,
                fill: data?.[0]?.buttonColor,
              }}
            >
              {data?.[0]?.buttonText?.split("/n").map((line, index) => (
                <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                  {line}
                </tspan>
              ))}
            </text>


            {/* Arrow/path */}
            <path
              d="M553.46,102.82h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
              fill="none"
              stroke={data?.[0]?.buttonColor}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>

        </svg>
      )}
    </>
  );
};

export default O1component;
